//Email - https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript/1373724

export const regExp = {
  "identityDomainName": "^[a-z][a-z0-9]{1,25}$",
  "personName" : "^([ ]+)*[a-zA-Z0-9\\u00C0-\\uFFFF][',. a-zA-Z0-9\\u00C0-\\uFFFF-]*([ ]+)*$",
  "organization" : "^[a-zA-Z0-9\\u00A0-\\uFFFF][a-zA-Z0-9\&\\u00A0-\\uFFFF',. ()@-]{0,199}[ ]*$",
  "altEnglishCompanyName": "^[a-zA-Z0-9][a-zA-Z0-9\&',. ()@-]{0,199}[ ]*$",
  "letters" : "^[a-zA-Z]*$",
  "letterNumbers":"^[a-zA-Z][a-zA-Z0-9]*$",
  "smsValidationCode" : "^[0-9]{6,12}[ ]*$",
  "phoneNumber": "^(?:[0-9] ?){6,14}[0-9]$",
  "email": /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
}

